export class AssertionError extends Error{constructor(r){super(r),this.name="AssertionError",Object.setPrototypeOf(this,AssertionError.prototype)}}